import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

const RATIO = 0.08;

export const IconGrid = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    // In this icon we use stroke instead of fill
    const currentStroke = isNumber(size) ? `${size * RATIO}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M5 6H7" strokeLinejoin="round" />
        <path d="M5 10.1666H7" strokeLinejoin="round" />
        <path d="M5 14.1666H7" strokeLinejoin="round" />
        <path d="M5 18.1666H7" strokeLinejoin="round" />
        <path d="M9 6H11" strokeLinejoin="round" />
        <path d="M9 10.1666H11" strokeLinejoin="round" />
        <path d="M9 14.1666H11" strokeLinejoin="round" />
        <path d="M9 18.1666H11" strokeLinejoin="round" />
        <path d="M13 6H15" strokeLinejoin="round" />
        <path d="M13 10.1666H15" strokeLinejoin="round" />
        <path d="M13 14.1666H15" strokeLinejoin="round" />
        <path d="M13 18.1666H15" strokeLinejoin="round" />
        <path d="M17 6H19" strokeLinejoin="round" />
        <path d="M17 10.1666H19" strokeLinejoin="round" />
        <path d="M17 14.1666H19" strokeLinejoin="round" />
        <path d="M17 18.1666H19" strokeLinejoin="round" />
      </svg>
    );
  }
);
